module.exports = {
  title: 'Selectable Grid List with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2023-06-28',
  slug: 'selectable-grid-list',
  tags: ['reanimated', 'gesture-handler'],
};
